export default __webpack_public_path__ + "static/media/dynargy_logo_verde_h.fae6220b.png";